import React from 'react';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import MobileNewReleaseGames from '@/pages/intelligence/pages/Potential/NewReleaseGames/MobileGame';

interface INewReleaseProps {
  /** TopCharts 主入口显式传递；Potential 复用入口不传时沿用 common 作用域。 */
  pageId?: string;
}

export default function NewRelease({ pageId }: INewReleaseProps) {
  const pageLogInfo = dbiPageLogMes.topchartsMobileGamesNewRelease;
  const entityType = 'mobile';
  return (
    <>
      <MarqueeBanner />
      <MobileNewReleaseGames entityType={entityType} pageLogInfo={pageLogInfo} pageId={pageId} enableStickyFilter enableMobileTopChartsFilterHoverTips />
    </>
  );
}
